<template>
    <div class="view cost-tasks">
        <app-sub-navbar parent="cost"></app-sub-navbar>
        Tasks
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'

export default {
    data () {
        return {

        }
    },
    components: {
        appSubNavbar: SubNavbar
    },
    created () {
    }
}
</script>
